import script from "./CardsAdministrador.vue?vue&type=script&setup=true&lang=js"
export * from "./CardsAdministrador.vue?vue&type=script&setup=true&lang=js"

import "./CardsAdministrador.vue?vue&type=style&index=0&id=5c57c321&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c57c321"]])

export default __exports__